import { LazyLoadImage } from "react-lazy-load-image-component";
import {
    FOLLOW_STATUS,
    FOLLOW_TIER,
    NUT_THEME_USERS,
    ROLES,
    s3Link,
    TRANSACTION_TYPE,
} from "../../utils/constants";
import PStatistics from "../PStatistics";
import Avatar from "../Avatar";
import TickSmall from "../../images/tick_small_edit.png";
import SendTipModal from "../PSendTipModal";
import PayPerViewModal from "../PPayPerViewModal";
import PRainbowToast from "../PRainbowToast";
import { CopyToClipboard } from "react-copy-to-clipboard";
import currency from "currency.js";
import React, { useCallback, useContext, useEffect, useState } from "react";
import CopyLink from "../../images/copylink.png";
import { useHistory, useParams } from "react-router-dom";
import moment from "moment/moment";
import { connect, useDispatch, useSelector } from "react-redux";
import PThankYou from "../PThankYou";
import PSignupModal from "../PSignupModal";
import { isMobile } from "react-device-detect";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { ProfileContext } from "./ProfileContext";
import useOnlineHook from "../../utils/useOnlineHook";
import { addChunkOnlinePresence } from "../../../redux/actions/user";
import {
    calculatePercentage,
    inFreeTiers,
    isLogin,
    notExpired,
} from "../../utils/helper";
import pusher from "../../utils/pusher";
import CountDownTimer from "../CountDownTimer";
import Subcovers from "./Subcovers";
import { resetOtherUserProfile } from "../../../redux/actions/otherUser";
import { Button } from "@mui/material";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import PaymentOptions from "../PaymentOptions";
import useDidMountEffect from "../../utils/useDidMountEffect";

const ReadMoreLess = ({ text, maxLength }) => {
    const [isFullTextVisible, setIsFullTextVisible] = useState(false);

    const toggleReadMore = () => {
        setIsFullTextVisible(!isFullTextVisible);
    };

    let tmpText = "";
    if (text.length <= maxLength) {
        tmpText = text;
    } else {
        // Find the last space within the maxLength
        const lastSpaceIndex = text.lastIndexOf(" ", maxLength);

        // If no space is found, truncate at the maxLength
        tmpText =
            lastSpaceIndex !== -1
                ? text.slice(0, lastSpaceIndex)
                : text.slice(0, maxLength);
    }

    const truncatedText = isFullTextVisible ? text : tmpText;

    return (
        <div>
            <div
                style={{ whiteSpace: "pre-wrap", display: "inline" }}
                dangerouslySetInnerHTML={{ __html: truncatedText }}
            />
            {text.length > maxLength && (
                <span>
                    {!isFullTextVisible ? "..." : ""}
                    <span
                        className="text-blue ml-1"
                        style={{ cursor: "pointer" }}
                        onClick={toggleReadMore}
                    >
                        {isFullTextVisible ? "Less" : "More"}
                    </span>
                </span>
            )}
        </div>
    );
};

/**
 * user is from profile/index
 *
 */
const ProfileContainer = ({
    user,
    coverPic,
    isProcessing,
    getUserInformation = () => ({}),
    subcovers = [],
    showCcVerification,
}) => {
    useOnlineHook();

    const history = useHistory();
    const params = useParams();
    const dispatch = useDispatch();
    const { processingIntent } = useContext(ProfileContext);

    const creditCardFormShow = useSelector(
        (state) => state.privaGlobal.creditCardForm.show
    );

    const [show, setShow] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showPPVModal, setShowPPVModal] = useState(false);
    const [conversation, setConversation] = useState("");
    const [showToast, setShowToast] = useState(false);
    const [link, setLink] = useState("");
    const [tipSuccess, setTipSuccess] = useState(false);
    const [showVerification, setShowVerification] = useState(false);
    const [promoUrl, setPromoUrl] = useState({});
    const [timeLeft, setTimeLeft] = useState("");
    const [profileLogo, setProfileLogo] = useState("");
    const [thankYou, setThankYou] = useState(false);
    const [signupFormStatus, setSignupFormStatus] = useState(false);
    const [followStatus, setFollowStatus] = useState(false);
    const [conversationIsLoading, setConversationIsLoading] = useState(false);
    const [savings, setSavings] = useState("");

    // pusher sequence
    const [puChannelName, setPuChannelName] = useState("");
    const [puChannel, setPuChannel] = useState(null);
    const [price, setPrice] = useState(0);
    const [subscriptionPrice, setSubscriptionPrice] = useState(0);
    const [showPaymentOptions, setShowPaymentOptions] = useState(false);
    const [triggerFollow, setTriggerFollow] = useState(false);

    const type = isLogin() ? "follow" : "signup";
    const handleModal = () => setShowModal(!showModal);
    const handlePPVModal = () => setShowPPVModal(!showPPVModal);
    const isThemeblk = () => {
        return NUT_THEME_USERS.includes(user.id);
    };

    const [freeSubscription, setFreeSubscription] = useState(false);
    const [containerMax, setContainerMax] = useState(0);
    const [currentWidth, setCurrentWidth] = useState(0);
    const [isExpanded, setIsExpanded] = useState(false);
    const [isPromo, setIsPromo] = useState(false);

    const profileBioContainerRef = useCallback((node) => {
        if (node) {
            setContainerMax(node.offsetWidth);
        }
    });

    const getConversation = () => {
        setConversationIsLoading(true);
        axios
            .get(`/api/conversations`, {
                params: {
                    to: params.username ? params.username : user.login,
                },
            })
            .then((response) => {
                setConversation(response.data);
            })
            .catch((error) => {
                console.log({ error });
            })
            .finally(() => {
                setConversationIsLoading(false);
            });
    };

    useEffect(() => {
        if (signupFormStatus) {
            window.location = "/edit-profile";
        }
    }, [signupFormStatus]);

    useDidMountEffect(() => {
        if (!show || !showPaymentOptions) {
            setTriggerFollow(false);
        }
    }, [show, showPaymentOptions]);

    useEffect(() => {
        if (followStatus) {
            getUserInformation();
            getConversation();
            setTriggerFollow(false); // used with payment options
        }
    }, [followStatus]);

    const handleSendMessage = (e) => {
        e.preventDefault();
        history.push(
            `/messages?conversation_id=${conversation.conversation_id}`
        );
    };

    const getProfileTheme = () => {
        return NUT_THEME_USERS.includes(user.id) ? "themeblk-follow-btn" : "";
    };

    const getProfileThemeDisabled = () => {
        return NUT_THEME_USERS.includes(user.id)
            ? "themeblk-follow-disabled"
            : "disable-link disabled";
    };

    useEffect(() => {
        setLink(window.location.href);

        const handleFollowClick = () => {
            handleShowPaymentOptions();
        };

        window.addEventListener("follow-click", handleFollowClick);

        return () => {
            dispatch(resetOtherUserProfile());
            window.removeEventListener("follow-click", handleFollowClick);
        };
    }, []);

    useEffect(() => {
        if (tipSuccess) {
            setShowModal(false);
            setTipSuccess(false);
            setThankYou(true);
        }
    }, [tipSuccess]);

    const [busyWithPromo, setBusyWithPromo] = useState(false);
    const validateDiscountLink = async (promoDetails) => {
        setBusyWithPromo(true);
        await axios
            .get("/api/promotions/url", {
                params: {
                    link_url: promoDetails.link_url || promoDetails.link,
                },
            })
            .then((response) => {
                if (response.data.status) {
                    setPromoUrl(response.data.promo);
                } else {
                    setPromoUrl({});
                    localStorage.removeItem("promo_url");
                }
                setBusyWithPromo(false);
            })
            .catch((error) => {
                setBusyWithPromo(false);
                localStorage.removeItem("promo_url");
            });
    };

    useEffect(() => {
        let mounted = true;
        if (
            user.role == ROLES.PU &&
            user.creator &&
            user.creator.promo_details &&
            user.creator.promo_details.promo_duration != 0
        ) {
            const duration = moment
                .utc(user.creator.promo_details.promo_start)
                .local()
                .add(user.creator.promo_details.promo_duration, "hours");
            setTimeLeft(duration);
        } else {
            setTimeLeft("No limit");
        }

        // Promo Code URL
        const promoUrlDetails = JSON.parse(localStorage.getItem("promo_url"));
        if (
            promoUrlDetails &&
            Object.keys(promoUrlDetails).length > 0 &&
            promoUrlDetails.user.id === user.id
        ) {
            validateDiscountLink(promoUrlDetails);
        }

        if (user) {
            if (isThemeblk()) {
                const accessDate = user.profile_photo_updated_at
                    ? user.profile_photo_updated_at
                    : new Date().valueOf();
                setProfileLogo(
                    `${s3Link}/${user.id}/profile_logo.png?t=${accessDate}`
                );
            }

            if (user.online_status) {
                dispatch(addChunkOnlinePresence([user.id]));
            }

            setPuChannelName(`private-story-${user.id}`);

            if (user && user.creator && Object.keys(user.creator).length > 0) {
                setFreeSubscription(user.creator.free_subscription);
            }
        }

        const handleResize = () => {
            setContainerMax(containerMax);
            setCurrentWidth(containerMax);
        };
        window.addEventListener("resize", handleResize);

        // Update price here @TODO
        let price = 0;
        if (user && user.creator && Object.keys(user.creator).length > 0) {
            price = history?.location?.state?.discount_data
                ? history.location.state.discount_data.link_price
                : user.creator.subscription_price;

            setIsPromo(!!history?.location?.state?.discount_data);
        }

        setSubscriptionPrice(price);

        return () => {
            mounted = false;
            window.removeEventListener("resize", handleResize);
        };
    }, [user]);

    const retrieveUserInfo = (data) => {
        if (user.id === data.id) {
            getUserInformation();
        }
    };

    useEffect(() => {
        if (puChannelName) {
            setPuChannel(pusher.subscribe(puChannelName));
        }
    }, [puChannelName]);

    useEffect(() => {
        if (puChannel) {
            puChannel.bind("App\\Events\\StoryEvent", (d) => {
                retrieveUserInfo(d);
            });
            puChannel.bind("App\\Events\\RemoveStoryEvent", (d) => {
                retrieveUserInfo(d);
            });
        }

        return () => {
            pusher.unsubscribe(puChannelName);
        };
    }, [puChannel]);

    useEffect(() => {
        if (promoUrl && Object.keys(promoUrl).length > 0) {
            let percent = calculatePercentage(
                promoUrl.is_free_link ? 0 : promoUrl.link_price,
                user.creator.subscription_price
            );
            setSavings(percent.toFixed(2).replace(".00", ""));
        }
    }, [promoUrl]);

    useEffect(() => {
        // if (user?.creator?.subscription_price || promoUrl?.link_price)
        let tmpPrice = 0;
        if (promoUrl && Object.keys(promoUrl).length > 0) {
            tmpPrice = currency(promoUrl.link_price).format({ precision: 2 });
        } else {
            if (
                user &&
                Object.keys(user).length > 0 &&
                user.creator &&
                Object.keys(user.creator).length > 0
            ) {
                tmpPrice = user.creator.subscription_price;
            }
        }

        setPrice(tmpPrice);
    }, [user, promoUrl]);

    const handleEndTime = () => {};

    const handleUpgradeFreeSubscription = (e) => {
        e.preventDefault();
        setShow(true);
    };

    const handleShowPaymentOptions = () => {
        // check if user is logged in or guest
        if (isLogin()) {
            setShowPaymentOptions(true);
        } else {
            setShow(true);
        }
    };

    const handlePayNow = () => {
        // setShow(true);
        // setShowPaymentOptions(false);
        setTriggerFollow(true);
    };

    useDidMountEffect(() => {
        if (!thankYou) {
            document.body.style.overflow = "auto";
        }
    }, [thankYou]);

    return (
        <>
            {thankYou && (
                <PThankYou show={thankYou} pu={user} setShow={setThankYou} />
            )}

            <PSignupModal
                showModal={show}
                setShowModal={setShow}
                user={user}
                type={type}
                setSignupFormStatus={setSignupFormStatus}
                setFollowStatus={setFollowStatus}
                getUserInformation={getUserInformation}
                discountData={history?.location?.state?.discount_data}
                isFree={
                    promoUrl &&
                    Object.keys(promoUrl).length > 0 &&
                    [FOLLOW_STATUS.UNSUBSCRIBED, false].includes(
                        user.subscription_status
                    ) &&
                    promoUrl &&
                    Object.keys(promoUrl).length > 0 &&
                    promoUrl.user.id === user.id &&
                    promoUrl.is_free_link
                }
                triggerFollow={triggerFollow}
            />

            <div
                className={`profile-container su-view ${
                    isThemeblk() ? "themeblk-profile-container" : ""
                }`}
            >
                <div
                    className={`${
                        isThemeblk()
                            ? "themeblk-profile-banner"
                            : "profile-banner "
                    }`}
                >
                    {coverPic ? <LazyLoadImage src={coverPic} /> : ""}
                </div>
                <div
                    className={`profile-banner-details ${
                        isThemeblk() ? "themeblk-profile-banner-details" : ""
                    }`}
                >
                    <div className="container">
                        <div className="profile-user-info-container">
                            {isThemeblk() &&
                                [ROLES.PU, ROLES.ADMIN].includes(
                                    parseInt(user.role)
                                ) && (
                                    <div className={"themeblk-profile-stats"}>
                                        {" "}
                                        <PStatistics user={user} />{" "}
                                    </div>
                                )}
                            <div className="profile-user-avatar-wrapper">
                                <div
                                    className={`${
                                        isThemeblk()
                                            ? "themeblk-profile-user-avatar"
                                            : "profile-user-avatar"
                                    }`}
                                >
                                    {isThemeblk() ? (
                                        <LazyLoadImage src={profileLogo} />
                                    ) : (
                                        <Avatar
                                            pu={user}
                                            size="125"
                                            showOnline={true}
                                            story={user.stories_count > 0}
                                            photoSize={75}
                                        />
                                    )}
                                </div>
                            </div>
                            {!isThemeblk() && (
                                <div className="profile-user-info-top">
                                    <div
                                        className={
                                            user.firstname
                                                ? "profile-user-name"
                                                : "profile-user-name no-fn"
                                        }
                                    >
                                        {user.firstname && (
                                            <h4>
                                                <b>{user.firstname}</b>{" "}
                                                <span className="ml-1">
                                                    <LazyLoadImage
                                                        src={TickSmall}
                                                    />
                                                </span>
                                            </h4>
                                        )}
                                        <p>@{user.login}</p>
                                    </div>
                                </div>
                            )}
                            <div
                                className={`profile-user-info-bottom ${
                                    isThemeblk()
                                        ? "themeblk-profile-user-info-bottom"
                                        : ""
                                }`}
                            >
                                <div
                                    className={`profile-user-bottom-list ${
                                        user.creator &&
                                        user.creator.promo_details &&
                                        user.creator.promo_details.promo_message
                                            ? " has-message"
                                            : ""
                                    }`}
                                >
                                    <div
                                        className={`${
                                            isThemeblk()
                                                ? "themeblk-profile-user-btns-container sprightly"
                                                : "profile-user-btns-container sprightly"
                                        }`}
                                    >
                                        {showModal &&
                                            !showCcVerification &&
                                            !creditCardFormShow && (
                                                <SendTipModal
                                                    user={user}
                                                    setShowModal={setShowModal}
                                                    show={showModal}
                                                    setTipSuccess={
                                                        setTipSuccess
                                                    }
                                                    setShowVerification={
                                                        setShowVerification
                                                    }
                                                />
                                            )}

                                        {isThemeblk() ? (
                                            <>
                                                <div className="profile-user-btns-container themeblk-profile-user-btns-container">
                                                    <OverlayTrigger
                                                        overlay={
                                                            <Tooltip
                                                                placement="top"
                                                                className="in"
                                                                id="tooltip-top"
                                                            >
                                                                Send Tip
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <a
                                                            className="sendtip-btn"
                                                            onClick={
                                                                handleModal
                                                            }
                                                        >
                                                            <span
                                                                className={
                                                                    "sendtip-icon"
                                                                }
                                                            >
                                                                <i className="fa-regular fa-circle-dollar"></i>
                                                            </span>
                                                        </a>
                                                    </OverlayTrigger>
                                                    <PayPerViewModal
                                                        user={user}
                                                        setShowModal={
                                                            setShowPPVModal
                                                        }
                                                        show={showPPVModal}
                                                        conversation={
                                                            conversation
                                                        }
                                                    />
                                                    <OverlayTrigger
                                                        overlay={
                                                            <Tooltip
                                                                placement="top"
                                                                className="in"
                                                                id="tooltip-top"
                                                            >
                                                                PPV Request
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <a
                                                            className="payperview-btn"
                                                            onClick={
                                                                handlePPVModal
                                                            }
                                                        >
                                                            <span
                                                                className={
                                                                    "payperview-icon "
                                                                }
                                                            >
                                                                <i className="fa-regular fa-messages-dollar"></i>
                                                            </span>
                                                        </a>
                                                    </OverlayTrigger>
                                                    <OverlayTrigger
                                                        overlay={
                                                            <Tooltip
                                                                placement="top"
                                                                className="in"
                                                                id="tooltip-top"
                                                            >
                                                                Message
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <a
                                                            className="message-btn"
                                                            onClick={
                                                                handleSendMessage
                                                            }
                                                        >
                                                            <span
                                                                className={
                                                                    "message-icon "
                                                                }
                                                            >
                                                                <i className="fa-regular fa-message-lines"></i>
                                                            </span>
                                                        </a>
                                                    </OverlayTrigger>
                                                    <OverlayTrigger
                                                        overlay={
                                                            <Tooltip
                                                                placement="top"
                                                                className="in"
                                                                id="tooltip-top"
                                                            >
                                                                Copy Link
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <CopyToClipboard
                                                            text={link}
                                                            onCopy={() =>
                                                                setShowToast(
                                                                    true
                                                                )
                                                            }
                                                        >
                                                            <a className="copy-link-btn">
                                                                <span>
                                                                    <i className="fa-regular fa-link-horizontal"></i>
                                                                </span>
                                                            </a>
                                                        </CopyToClipboard>
                                                    </OverlayTrigger>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                {[
                                                    FOLLOW_STATUS.ACTIVE,
                                                    FOLLOW_STATUS.PAUSED,
                                                    FOLLOW_STATUS.UNFOLLOWED_DOES_NOT_RENEW,
                                                ].includes(
                                                    user.subscription_status
                                                ) ? (
                                                    <React.Fragment>
                                                        <PayPerViewModal
                                                            user={user}
                                                            setShowModal={
                                                                setShowPPVModal
                                                            }
                                                            show={showPPVModal}
                                                            conversation={
                                                                conversation
                                                            }
                                                        />
                                                        <OverlayTrigger
                                                            overlay={
                                                                <Tooltip
                                                                    placement="top"
                                                                    className="in"
                                                                    id="tooltip-top"
                                                                >
                                                                    Send Tip
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <a
                                                                onClick={
                                                                    handleModal
                                                                }
                                                                className={
                                                                    "sendtip-btn"
                                                                }
                                                            >
                                                                <span
                                                                    className={
                                                                        "sendtip-icon"
                                                                    }
                                                                >
                                                                    <i className="fa-regular fa-circle-dollar"></i>
                                                                </span>
                                                            </a>
                                                        </OverlayTrigger>
                                                        <OverlayTrigger
                                                            overlay={
                                                                <Tooltip
                                                                    placement="top"
                                                                    className="in"
                                                                    id="tooltip-top"
                                                                >
                                                                    PPV Request
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <a
                                                                onClick={
                                                                    handlePPVModal
                                                                }
                                                                className={
                                                                    "ppv-btn"
                                                                }
                                                            >
                                                                <span
                                                                    className={
                                                                        "payperview-icon "
                                                                    }
                                                                >
                                                                    <i className="fa-regular fa-messages-dollar"></i>
                                                                </span>
                                                            </a>
                                                        </OverlayTrigger>
                                                        <OverlayTrigger
                                                            overlay={
                                                                <Tooltip
                                                                    placement="top"
                                                                    className="in"
                                                                    id="tooltip-top"
                                                                >
                                                                    Message
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <a
                                                                className={
                                                                    "message-btn"
                                                                }
                                                                onClick={
                                                                    handleSendMessage
                                                                }
                                                            >
                                                                <span
                                                                    className={
                                                                        "message-icon "
                                                                    }
                                                                >
                                                                    <i className="fa-regular fa-message-lines"></i>
                                                                </span>
                                                            </a>
                                                        </OverlayTrigger>

                                                        <OverlayTrigger
                                                            overlay={
                                                                <Tooltip
                                                                    placement="top"
                                                                    className="in"
                                                                    id="tooltip-top"
                                                                >
                                                                    Copy Link
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <CopyToClipboard
                                                                text={link}
                                                                onCopy={() =>
                                                                    setShowToast(
                                                                        true
                                                                    )
                                                                }
                                                            >
                                                                <a className="copy-link-btn">
                                                                    <span>
                                                                        <i className="fa-regular fa-link-horizontal"></i>
                                                                    </span>
                                                                </a>
                                                            </CopyToClipboard>
                                                        </OverlayTrigger>
                                                    </React.Fragment>
                                                ) : (
                                                    <React.Fragment>
                                                        <OverlayTrigger
                                                            overlay={
                                                                <Tooltip
                                                                    placement="top"
                                                                    className="in"
                                                                    id="tooltip-top"
                                                                >
                                                                    Copy Link
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <CopyToClipboard
                                                                text={link}
                                                                onCopy={() =>
                                                                    setShowToast(
                                                                        true
                                                                    )
                                                                }
                                                            >
                                                                <a className="copy-link-btn">
                                                                    <span>
                                                                        <i className="fa-regular fa-link-horizontal"></i>
                                                                    </span>
                                                                </a>
                                                            </CopyToClipboard>
                                                        </OverlayTrigger>

                                                        {/* Free subscription button */}
                                                        {![1, 30167].includes(
                                                            user.id
                                                        ) &&
                                                        user.role == ROLES.PU &&
                                                        user.creator &&
                                                        user.creator
                                                            .free_subscription &&
                                                        [
                                                            FOLLOW_STATUS.UNSUBSCRIBED,
                                                            false,
                                                        ].includes(
                                                            user.subscription_status
                                                        ) ? (
                                                            <button
                                                                onClick={() =>
                                                                    setShow(
                                                                        true
                                                                    )
                                                                }
                                                                id="btn-free-follow"
                                                                className={`btn theme-btn theme-btn-bordered btn-follow text-uppercase ${getProfileTheme()} ${
                                                                    isProcessing ||
                                                                    processingIntent
                                                                        ? getProfileThemeDisabled()
                                                                        : ""
                                                                }`}
                                                            >
                                                                {isProcessing ||
                                                                processingIntent
                                                                    ? "Processing..."
                                                                    : `Follow`}
                                                            </button>
                                                        ) : null}
                                                    </React.Fragment>
                                                )}
                                                {/* {
                                                !isMobile && [FOLLOW_STATUS.ACTIVE, FOLLOW_STATUS.PAUSED, FOLLOW_STATUS.UNFOLLOWED_DOES_NOT_RENEW].includes(user.subscription_status) && user.creator && user.creator.pause_status
                                                    ? <div className={'pause-account-container'}><span className="account_paused">Account Paused</span></div>
                                                    : ''
                                            } */}
                                            </>
                                        )}
                                    </div>
                                    {isMobile &&
                                    [
                                        FOLLOW_STATUS.ACTIVE,
                                        FOLLOW_STATUS.PAUSED,
                                        FOLLOW_STATUS.UNFOLLOWED_DOES_NOT_RENEW,
                                    ].includes(user.subscription_status) &&
                                    user.creator &&
                                    user.creator.pause_status ? (
                                        <div
                                            className={
                                                "pause-account-container"
                                            }
                                        >
                                            <span className="account_paused">
                                                Account Paused
                                            </span>
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                </div>
                                {!isThemeblk() &&
                                    [ROLES.PU, ROLES.ADMIN].includes(
                                        parseInt(user.role)
                                    ) && <PStatistics user={user} />}
                            </div>
                        </div>
                    </div>
                    {!isThemeblk() && (
                        <div className="profile-copy-link">
                            <PRainbowToast
                                show={showToast}
                                setShow={setShowToast}
                                message={`Copied Link to ${user.login} profile!`}
                            />
                        </div>
                    )}
                </div>

                <div
                    className={`bio-promo-container ${
                        user.firstname ? "" : "no-fn"
                    }`}
                >
                    {![1, 30167].includes(user.id) &&
                        user.role === ROLES.PU &&
                        user.creator &&
                        user.creator.promo_details &&
                        Object.keys(user.creator.promo_details).length <= 0 &&
                        [ROLES.PU, ROLES.ADMIN].includes(user.role) &&
                        user.subscription_status === 1 &&
                        user.tier &&
                        user.tier != FOLLOW_TIER.PROMO_PLAN && (
                            <a
                                onClick={() => {
                                    history.push("/following");
                                }}
                                className="btn theme-btn theme-btn-bordered text-uppercase"
                            >
                                Re-follow
                            </a>
                        )}

                    <div
                        className="profile-bio-container"
                        ref={profileBioContainerRef}
                    >
                        <div
                            className="profile-bio-more"
                            style={{
                                whiteSpace:
                                    isExpanded || isThemeblk()
                                        ? "pre-line"
                                        : "unset",
                            }}
                        >
                            {user.creator &&
                            user.creator.pause_status &&
                            user.creator.pause_text ? (
                                <div className="my-2">
                                    {user.creator.pause_text}
                                </div>
                            ) : (
                                ""
                            )}
                            {user.creator && user.creator.bio && (
                                <>
                                    {isThemeblk() ? (
                                        <span>{user.creator.bio}</span>
                                    ) : (
                                        <ReadMoreLess
                                            text={user.creator.bio}
                                            maxLength={55}
                                        />
                                    )}
                                </>
                            )}
                        </div>
                    </div>

                    {/* PROMO SECTION */}
                    {((!promoUrl || Object.keys(promoUrl).length <= 0) &&
                        ![1, 30167].includes(user.id) &&
                        user.role === ROLES.PU &&
                        user.creator &&
                        [FOLLOW_STATUS.UNSUBSCRIBED, false].includes(
                            user.subscription_status
                        ) &&
                        user.creator.promo_details &&
                        Object.keys(user.creator.promo_details).length > 0) ||
                    // check for Free following and show limited offer details
                    (notExpired(user.subscription_status) &&
                        (inFreeTiers(user.tier) ||
                            inFreeTiers(user.follow_tier)) &&
                        user.creator &&
                        user.creator.promo_details &&
                        Object.keys(user.creator.promo_details).length > 0) ? (
                        <div className="promo">
                            <div
                                className="row"
                                style={
                                    inFreeTiers(user.tier) ||
                                    inFreeTiers(user.follow_tier)
                                        ? {
                                              paddingLeft: 0,
                                          }
                                        : {}
                                }
                            >
                                <div className="col-md-12">
                                    <p className="promo-blue-header">
                                        <b>
                                            Limited Offer{" "}
                                            {user.creator.promo_details.save}%
                                            OFF! &nbsp;
                                            <span>
                                                {currency(
                                                    user.creator.promo_details
                                                        .promo_price
                                                ).format({ currency: "" })}
                                            </span>{" "}
                                            USD for 1 month
                                        </b>
                                    </p>

                                    <div
                                        className={`promo-end-count ${
                                            user.creator.promo_details
                                                .promo_limit != 0
                                                ? "has-promo-limit"
                                                : ""
                                        }`}
                                    >
                                        <h5>
                                            Promo ends:&nbsp;
                                            <span className="blue_text">
                                                {timeLeft === "No limit" ? (
                                                    timeLeft
                                                ) : (
                                                    <CountDownTimer
                                                        dateTime={timeLeft}
                                                        isUTC={true}
                                                        onEndTime={
                                                            handleEndTime
                                                        }
                                                    />
                                                )}
                                            </span>
                                        </h5>

                                        {user.creator.promo_details
                                            .promo_limit != 0 && (
                                            <h5 className="promos-left">
                                                Promos left:{" "}
                                                <span className="blue_text">
                                                    {user.creator.promo_details
                                                        .promo_limit == 0
                                                        ? "Unlimited"
                                                        : parseInt(
                                                              user.creator
                                                                  .promo_details
                                                                  .promo_limit
                                                          ) -
                                                          parseInt(
                                                              user.creator
                                                                  .promo_details
                                                                  .promo_limit_used
                                                          )}
                                                </span>
                                            </h5>
                                        )}
                                    </div>

                                    {user.creator.promo_details
                                        .promo_message && (
                                        <div
                                            className="promo-profile-text"
                                            dangerouslySetInnerHTML={{
                                                __html: user.creator
                                                    .promo_details
                                                    .promo_message,
                                            }}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    ) : (
                        ""
                    )}

                    {/* FOLLOW BUTTON CONTAINER - START */}
                    <div className="follow-btn-container">
                        {
                            // btn theme-btn theme-btn-bordered btn-follow
                            inFreeTiers(user.follow_tier) &&
                            notExpired(user.subscription_status) ? (
                                <div
                                    style={{
                                        display: "block",
                                        width: "100%",
                                        marginBottom: "12px",
                                    }}
                                >
                                    <Button
                                        className="btn theme-btn theme-btn-bordered btn-follow text-uppercase btn-info"
                                        onClick={(e) => e.preventDefault()}
                                        variant="outlined"
                                        sx={{
                                            "& .MuiButtonBase-root:hover": {
                                                background: "white",
                                                color: "#0097fe",
                                            },
                                            borderRadius: "20px",
                                            fontSize: "14px",
                                            fontWeight: 700,
                                        }}
                                        disableRipple
                                    >
                                        Following for Free
                                    </Button>
                                </div>
                            ) : null
                        }

                        {(!promoUrl || Object.keys(promoUrl).length <= 0) &&
                        ![1, 30167].includes(user.id) &&
                        user.creator &&
                        user.creator.promo_details &&
                        Object.keys(user.creator.promo_details).length <= 0 &&
                        [ROLES.PU, ROLES.ADMIN].includes(user.role) &&
                        [false, FOLLOW_STATUS.UNSUBSCRIBED].includes(
                            user.subscription_status
                        ) &&
                        !freeSubscription &&
                        subscriptionPrice > 0 ? (
                            <a
                                onClick={handleShowPaymentOptions}
                                className={`btn theme-btn theme-btn-bordered btn-follow text-uppercase ${getProfileTheme()} ${
                                    isProcessing || processingIntent
                                        ? getProfileThemeDisabled()
                                        : ""
                                }`}
                            >
                                {isProcessing || processingIntent
                                    ? "Processing..."
                                    : `Subscribe ${currency(
                                          subscriptionPrice
                                      ).format({
                                          precision: 2,
                                      })}`}
                            </a>
                        ) : null}

                        {/* unsubscribed showing promo price */}
                        {(!promoUrl || Object.keys(promoUrl).length <= 0) &&
                            ![1, 30167].includes(user.id) &&
                            user.role == ROLES.PU &&
                            user.creator &&
                            user.creator.promo_details &&
                            Object.keys(user.creator.promo_details).length >
                                0 &&
                            [FOLLOW_STATUS.UNSUBSCRIBED, false].includes(
                                user.subscription_status
                            ) &&
                            !freeSubscription &&
                            user.creator.promo_details.promo_price > 0 && (
                                <a
                                    onClick={handleShowPaymentOptions}
                                    className={`btn btn-follow theme-btn theme-btn-bordered text-uppercase ${getProfileTheme()}  ${
                                        isProcessing || processingIntent
                                            ? getProfileThemeDisabled()
                                            : ""
                                    }`}
                                >
                                    {isProcessing || processingIntent
                                        ? "Processing"
                                        : `Subscribe ${
                                              user && user.creator
                                                  ? `${currency(
                                                        user.creator
                                                            .promo_details
                                                            .promo_price
                                                    ).format({ precision: 2 })}`
                                                  : ""
                                          }`}
                                </a>
                            )}

                        {/* User has already subscribed on a free tier plan. Show follow PROMO subscription price */}
                        {freeSubscription &&
                        notExpired(user.subscription_status) &&
                        inFreeTiers(user.follow_tier) &&
                        user.creator &&
                        user.creator.promo_details &&
                        Object.keys(user.creator.promo_details).length > 0 &&
                        user.creator.promo_details.promo_price > 0 ? (
                            <a
                                onClick={handleUpgradeFreeSubscription}
                                className={`btn btn-follow theme-btn theme-btn-bordered text-uppercase  ${getProfileTheme()}  ${
                                    isProcessing || processingIntent
                                        ? getProfileThemeDisabled()
                                        : ""
                                }`}
                            >
                                {" "}
                                {isProcessing || processingIntent
                                    ? "Processing"
                                    : `Subscribe ${
                                          user && user.creator
                                              ? `${currency(
                                                    user.creator.promo_details
                                                        .promo_price
                                                ).format({ precision: 2 })}`
                                              : ""
                                      }`}
                            </a>
                        ) : null}

                        {/* User has already subscribed on a free tier plan. Show follow regular subscription price */}
                        {freeSubscription &&
                        notExpired(user.subscription_status) &&
                        inFreeTiers(user.follow_tier) &&
                        user.creator &&
                        user.creator.promo_details &&
                        Object.keys(user.creator.promo_details).length <= 0 &&
                        user.creator.subscription_price > 0 ? (
                            <a
                                onClick={handleUpgradeFreeSubscription}
                                className={`btn btn-follow theme-btn theme-btn-bordered text-uppercase  ${getProfileTheme()}  ${
                                    isProcessing || processingIntent
                                        ? getProfileThemeDisabled()
                                        : ""
                                }`}
                            >
                                {" "}
                                {isProcessing || processingIntent
                                    ? "Processing"
                                    : `Subscribe ${
                                          user && user.creator
                                              ? `${currency(
                                                    user.creator
                                                        .subscription_price
                                                ).format({ precision: 2 })}`
                                              : ""
                                      }`}
                            </a>
                        ) : null}

                        {/* Free subscription link/promo link price button */}
                        {promoUrl &&
                            Object.keys(promoUrl).length > 0 &&
                            [FOLLOW_STATUS.UNSUBSCRIBED, false].includes(
                                user.subscription_status
                            ) &&
                            !freeSubscription &&
                            promoUrl &&
                            Object.keys(promoUrl).length > 0 &&
                            promoUrl.user.id === user.id &&
                            (promoUrl.is_free_link ? (
                                <a
                                    onClick={() => setShow(true)}
                                    className={`btn btn-follow theme-btn theme-btn-bordered text-uppercase free-trial  ${getProfileTheme()} ${
                                        isProcessing
                                            ? getProfileThemeDisabled()
                                            : ""
                                    }`}
                                >
                                    {isProcessing
                                        ? "Processing"
                                        : "Follow for free"}
                                </a>
                            ) : (
                                <a
                                    onClick={() => setShow(true)}
                                    className={`btn btn-follow theme-btn theme-btn-bordered text-uppercase free-trial  ${getProfileTheme()} ${
                                        isProcessing
                                            ? getProfileThemeDisabled()
                                            : ""
                                    }`}
                                >
                                    {isProcessing
                                        ? "Processing"
                                        : `Subscribe ${
                                              user && user.creator
                                                  ? `${currency(
                                                        promoUrl.link_price
                                                    ).format({ precision: 2 })}`
                                                  : ""
                                          }`}

                                    {/* ${user && user.creator ? `${currency(promoUrl.link_price).format({ precision: 2 })}` : ''} */}
                                </a>
                            ))}
                    </div>
                    {/* FOLLOW BUTTON CONTAINER - END */}

                    {isThemeblk() && subcovers.length > 0 && (
                        <div
                            className={"themeblk-profile-subscovers-container"}
                        >
                            <Subcovers subcovers={subcovers} />
                        </div>
                    )}
                </div>
            </div>
            <PaymentOptions
                show={showPaymentOptions}
                setShow={setShowPaymentOptions}
                onClickPayNow={handlePayNow}
                action={TRANSACTION_TYPE.SUBSCRIPTION}
                pu={user}
                onSuccess={getUserInformation}
                isPromo={isPromo}
                price={subscriptionPrice}
            />
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        isProcessing: state.follow.isProcessing,
        showCcVerification: state.ccVerification.showVerify,
    };
};

export default React.memo(connect(mapStateToProps)(ProfileContainer));
